import SingleProduct from '../components/single-product.svelte'
import SingleProductVariation from '../components/single-product-variation.svelte'
import { getJquery } from '../js/util'

let $ = getJquery()

export default {
	init() {
		let $body = $('body')

		if ($('.single-product').length) {
			const $giftCardForm = $('.gift-cards_form')

			if ($('.variations_form').length) {
				new SingleProductVariation({
					target: document.body,
				})
			} else if (!$giftCardForm.length) {
				new SingleProduct({
					target: document.body,
				})
			}

			if ($body.hasClass('wcopc-product-single')) {
				// if one page checkout product
				// let $swag_bag_id = $('#opc-product-selection').attr('data-opc_id')
				// if ($body.hasClass('postid-' + $swag_bag_id)) {
				// if swag bag product
				swagBagPage()
				// }
			}
		}
	},
	finalize() {},
}

function swagBagPage() {
	$(document).ready(function () {
		//Left Column
		//form field logic
		let $formCheckout = $('form.woocommerce-checkout')
		if ($formCheckout.length) {
			let $billingFields = $(
				'.woocommerce-billing-fields__field-wrapper p:not(.form-row-first, .form-row-last), .woocommerce-shipping-fields, .woocommerce-additional-fields, #customer_details > .col-2'
			)
			$billingFields.addClass('hide-swag-fields') // hide fields

			let $activeFields = $(
				'.woocommerce-billing-fields__field-wrapper .form-row-first input, .woocommerce-billing-fields__field-wrapper .form-row-last input'
			)
			$activeFields.on('click', function () {
				$billingFields.removeClass('hide-swag-fields')
			})
		}

		let $giftingOption = $('#gifting_0_option')
		if ($giftingOption.length) {
			let $giftSwagButton = $('#swagHeroBtns a[data-btn-txt*="Gift"]')
			if ($giftSwagButton.length) {
				$giftSwagButton.on('click', function () {
					setTimeout(() => {
						$giftingOption.click()
					}, 1000)
				})
			}
		}

		let $giftProduct = $('#giftProduct')
		//move add to cart btn
		$giftProduct.insertBefore($('form.checkout'))
		//reveal billing fields after adding product to cart
		$('.single_add_to_cart_button').on('click', function () {
			$('#customer_details').addClass('reveal-checkout')
		})

		//if cart already has item reveal billing fields
		if ($('#order_review').find('.cart_item').length > 0) {
			$('#customer_details').addClass('reveal-checkout')
		}

		//Right Column
		//disable payments (right column)
		let $oldPaymentForm = $('#order_review #payment')
		if ($oldPaymentForm.length) {
			$oldPaymentForm.remove()
		}

		//position checkout form
		let $leftColumnProductSelection = $('#opc-product-selection')
		if ($leftColumnProductSelection.length) {
			let stickyPosition =
				$('#giftProduct').outerHeight() +
				$('#boostFormContent').outerHeight() +
				$('.woocommerce-form-coupon-toggle').outerHeight() +
				$('form.checkout').outerHeight() * 1.19
			let $orderReviewParentJquery = $('form.woocommerce-checkout')
			let $orderReview = document.getElementById('order_review')
			$orderReview.style.marginTop =
				-Math.round(Math.min(stickyPosition, 510)) + 'px'

			//prevent user from submitting the form with 'Enter' key
			$orderReviewParentJquery.keypress(function (e) {
				if (e.which == '13') {
					e.preventDefault()
				}
			})

			let $termsListItem = $('#termsListItem')
			let $secondaryTermsListItem = $('#secondaryTermsListItem')
			let $placeOrderBtn = $('#place_order_2')
			//add/remove btn styles
			$termsListItem.on('click', function () {
				let $termsCheckbox = $('#termsCheckbox')
				if ($termsCheckbox.is(':checked')) {
					$placeOrderBtn.removeClass('disable-btn')
				} else {
					$placeOrderBtn.addClass('disable-btn')
				}
			})

			//add customer info to mailchimp form
			let $mailChimpForm = $('#swagChimp form')
			let $newsletterCheckbox = $('#newsletterCheckbox')
			$secondaryTermsListItem.on('click', function () {
				let $billingForm = $('form.woocommerce-checkout')
				if ($billingForm.length) {
					let $email = $('#billing_email').val()
					if ($newsletterCheckbox.is(':checked')) {
						if ($mailChimpForm.length) {
							$('#swagChimp .mc-email-field .ginput_container_email input').val(
								$email
							)
						}
					}
				}
			})

			//submit mailchimp form if newsletter is checked
			$placeOrderBtn.on('click', function () {
				if ($newsletterCheckbox.is(':checked')) {
					if ($mailChimpForm.length) {
						$mailChimpForm.submit()
					}
				}
			})

			//append divs
			let $boostPurchaseWrap = $('#boostPurchaseWrap')
			let $customer_details_col_2 = $('#customer_details .col-2')
			if ($boostPurchaseWrap.length) {
				let $payment = $('#payment')
				$boostPurchaseWrap.detach()
				$boostPurchaseWrap.appendTo($orderReview)
				$payment.detach()
				$payment.appendTo($customer_details_col_2)
			}

			//change btns text
			let $singleAddToCartButton = $('.single_add_to_cart_button')
			if ($singleAddToCartButton.length) {
				$singleAddToCartButton.text('add monthly swag bag to cart')
			}
		}
	})
}
